import React, { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Preloader from "../components/Preloader";

//Custom Components

import Home from "../pages/home";
import About from "../pages/about";
import Course from "../pages/course";
import CourseDetails from "../pages/course/CourseDetails";
import Instructor from "../pages/instructor";
import Blog from "../pages/blog";
import BlogDetails from "../pages/blog/BlogDetails";
import Contact from "../pages/contact";
import Error from "../pages/404";
import LoadTop from "../components/ScrollTop/LoadTop";
import CourseKid from "../pages/course/CourseKid";
import CourseNative from "../pages/course/CourseNative";
import Book from "../pages/course/Book";
import Checkout from "../pages/course/Checkout";
import LevelTest from "../pages/course/LevelTest";
import Quotation from "../pages/quotation";
import CourseVideo from "../pages/course/CourseVideo";
import Zoom from "../pages/zoom";
import Password from "../components/Password";
import Video from "../pages/Video";
import Profile from "../pages/profile";
import Register from "../pages/Register";
import Login from "../pages/Login";
import EventPage from "../pages/event";


const App = () => {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Simulate data loading delay
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, []);

  return (
    <div className="App">
      {isLoading ? <Preloader /> : ""}
      <>
        <LoadTop />
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/instructor" exact element={<Instructor />} />
          <Route path="/adult" element={<Course />} />
          <Route path="/courses/:title" element={<CourseKid />} />
          {/* <Route path="/video" element={<CourseVideo />} />
          <Route path="/native" element={<CourseNative />} /> */}
          <Route path="/books" element={<Book />} />
          <Route path="/level-test" element={<LevelTest />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/coursesDetail/:title" element={<CourseDetails />} />
          <Route path="/blog" exact element={<Blog />} />
          <Route path="/blog/:title" element={<BlogDetails />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/quotation" element={<Quotation />} />
          <Route path="/zoom" element={<Zoom />} />
          <Route path="/event" element={<EventPage/>} />
          <Route path="/reset_password" element={<Password />} />
          <Route path="/payment" element={<Video />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="*" element={<Error />} />
        </Routes>
      </>
    </div>
  );
};

export default App;
